import { ADICIONAR_FILTRO_TOMADOR, REMOVER_FILTRO_TOMADOR } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

export const filtrosAdicionadosTomador = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_TOMADOR: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_TOMADOR: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}
